module.exports = __webpack_public_path__ + "static/media/face-3.03aaec1f.jpg";